import React from 'react';
import { FormattedMessage } from 'react-intl';

import * as D from '../deps';

import './BackstageLongPlayButton.scss';

export interface IBackstageLongPlayButtonOwnProps {
  playOnClick: $TSFixMeFunction;
  isArtist: boolean;
}

export type IBackstageLongPlayButtonProps = IBackstageLongPlayButtonOwnProps;

export const BackstageLongPlayButton: React.FC<IBackstageLongPlayButtonOwnProps> = props => {
  const { playOnClick, isArtist } = props;

  const classes = D.createBEM('BackstageLongPlayButton', {
    artist: isArtist,
  });

  return (
    <div className={classes}>
      <D.ButtonT3
        isPillShaped={true}
        onClick={playOnClick}
        isInverted={true}
        theme={D.ButtonT3Theme.BLACK}
        iconType='play'
        qaTag={D.QA.BSATM}
      >
        <FormattedMessage {...D.Constants.Onboarding.messages.listenInTheAppText} />
      </D.ButtonT3>
    </div>
  );
};

export default BackstageLongPlayButton;
